import { CategoryDocumentOutputDTO } from '@types';

export const CategoryDocumentMapper = {
  toDTO: (data: Partial<CategoryDocumentOutputDTO>): Partial<CategoryDocumentOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: CategoryDocumentOutputDTO): CategoryDocumentOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 